// extracted by mini-css-extract-plugin
export default {"root":"IconSortArrows_root__Mkg6f"};